import React, { FC } from 'react';
import AdditionalInfoMobile from './AdditionalInfoMobile';
import AdditionalInfoDesktop from './AdditionalInfoDesktop';
import { useTemplateContext } from '@components/Contexts/TemplateContext';

type AdditionalInfoProps = {
  isMobileView: boolean;
};

const AdditionalInfo: FC<AdditionalInfoProps> = ({ isMobileView }) => {
  const { template } = useTemplateContext();
  const { title, hasAdditionalPurchaseApps, id } = template;
  return isMobileView ? (
    <AdditionalInfoMobile
      hasAdditionalPurchaseApps={hasAdditionalPurchaseApps}
    />
  ) : (
    <AdditionalInfoDesktop
      listingId={id}
      templateName={title}
      hasAdditionalPurchaseApps={hasAdditionalPurchaseApps}
    />
  );
};

export default AdditionalInfo;
